import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from "react";
import { useVirtualizer } from "../../../lib/virtual";
import { Accordion } from "../../../components/shadcn/accordion";
import Row from "./Rows";
import { LayoutGroup, motion } from "framer-motion";
import useWallet from "../../../hooks/useWallet";
import { useProvidersConnectReady } from "@layerswap/wallet-core";
import ConnectWalletButton from "../../../components/Common/ConnectWalletButton";
import clsx from "clsx";
import RouteSearch from "./RouteSearch";
import NavigatableList from "../../../components/NavigatableList";
import { useSelectorState } from "../../../components/Select/Selector/Index";
export const Content = (props) => {
    const [isItemsScrolling, setIsItemsScrolling] = useState(false);
    return _jsxs(_Fragment, { children: [_jsx(RouteSearch, { searchQuery: props.searchQuery, setSearchQuery: props.setSearchQuery, shouldFocus: true, direction: props.direction }), _jsx(Items, { ...props, isScrolling: isItemsScrolling, setIsScrolling: setIsItemsScrolling })] });
};
const Items = ({ searchQuery, setSearchQuery, rowElements, selectedToken, selectedRoute, direction, onSelect, isScrolling, setIsScrolling, hideTokenSwitch, hideBalances, hideConnectButton }) => {
    const parentRef = useRef(null);
    const [openValues, setOpenValues] = useState(selectedRoute ? [selectedRoute] : []);
    const { wallets } = useWallet();
    const { shouldFocus } = useSelectorState();
    const isSingleNetwork = useMemo(() => {
        if (!searchQuery)
            return false;
        return rowElements.filter(r => r.type === 'network').length === 1;
    }, [searchQuery, rowElements]);
    const onReset = useMemo(() => searchQuery ? (() => { }) : undefined, [searchQuery]);
    useEffect(() => {
        if (!isSingleNetwork)
            return;
        const network = rowElements.find(r => r.type === 'network');
        if (network) {
            setOpenValues(prev => prev.includes(network.route.name) ? prev : [...prev, network.route.name]);
        }
    }, [isSingleNetwork, rowElements]);
    const isProvidersReady = useProvidersConnectReady();
    const scrollTimeout = useRef(null);
    const handleScroll = () => {
        setIsScrolling(true);
        if (scrollTimeout.current)
            clearTimeout(scrollTimeout.current);
        scrollTimeout.current = setTimeout(() => {
            setIsScrolling(false);
        }, 1000);
    };
    useEffect(() => {
        return () => clearTimeout(scrollTimeout.current);
    }, []);
    const toggleAccordionItem = (value) => {
        setOpenValues((prev) => prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]);
    };
    const virtualizer = useVirtualizer({
        count: rowElements.length,
        estimateSize: (index) => {
            const item = rowElements[index];
            const key = item?.route?.name || item?.symbol;
            const isOpen = openValues.includes(key);
            // Better size estimation based on open state
            if (isOpen && (item.type === 'network' || item.type === 'grouped_token')) {
                const tokenCount = item.type === 'network'
                    ? item.route.tokens.length
                    : item.items.length;
                // Base header (52) + tokens (each ~52px) + padding
                return 52 + (tokenCount * 52) + 20;
            }
            return 52;
        },
        getScrollElement: () => parentRef.current,
        overscan: 15
    });
    useEffect(() => {
        virtualizer.measure();
    }, [openValues]);
    const items = virtualizer.getVirtualItems();
    useEffect(() => {
        return () => setSearchQuery('');
    }, []);
    return _jsx(NavigatableList, { enabled: shouldFocus, onReset: onReset, navigateToFirstChild: isSingleNetwork, children: _jsx(LayoutGroup, { children: _jsxs(motion.div, { layoutScroll: true, onScroll: handleScroll, className: clsx("select-text in-has-[.hide-main-scrollbar]:overflow-y-hidden overflow-y-auto overflow-x-hidden scrollbar:w-1! scrollbar:h-1! pr-0.5 scrollbar-thumb:bg-transparent h-full", { "styled-scroll!": isScrolling }), ref: parentRef, children: [!hideConnectButton && wallets.length === 0 && direction === 'from' && !searchQuery &&
                        _jsx(ConnectWalletButton, { descriptionText: "Connect your wallet to browse your assets and choose easier", className: "w-full my-2.5", disabled: !isProvidersReady }), _jsx("div", { className: "relative", children: _jsx(Accordion, { type: "multiple", value: openValues, children: _jsx("div", { children: _jsxs("div", { style: {
                                        height: virtualizer.getTotalSize(),
                                        width: '100%',
                                        position: 'relative',
                                    }, children: [_jsx("div", { className: "sticky top-0 z-50", id: "sticky_accordion_header" }), _jsx("div", { style: {
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                transform: `translateY(${items[0]?.start ? (items[0]?.start - 0) : 0}px)`,
                                            }, children: items.map((virtualRow) => {
                                                const data = rowElements?.[virtualRow.index];
                                                const key = data?.route?.name || virtualRow.key;
                                                return _jsx("div", { className: "py-1 box-border w-full overflow-hidden select-none", "data-index": virtualRow.index, ref: virtualizer.measureElement, children: _jsx(Row, { index: virtualRow.index, scrollContainerRef: parentRef, openValues: openValues, onSelect: onSelect, direction: direction, item: data, selectedRoute: selectedRoute, selectedToken: selectedToken, searchQuery: searchQuery, toggleContent: toggleAccordionItem, hideTokenSwitch: hideTokenSwitch, hideBalances: hideBalances }) }, key);
                                            }) })] }) }) }) })] }) }) });
};
